module.exports = __webpack_public_path__ + "files/fae85e5084fbd06d8c27393712aaeb63.png";